export const getOrganizationId = (): string | null => {
  if (typeof window === 'undefined') return null;

  try {
    const rawUser = window.localStorage.getItem('user');
    if (!rawUser) return null;

    const user = JSON.parse(rawUser);
    return user?.organization_id || user?.organizationId || null;
  } catch {
    return null;
  }
};

export const withOrganizationId = <T extends Record<string, any>>(payload: T): T & { organization_id?: string } => {
  const organizationId = getOrganizationId();
  if (!organizationId) return payload;
  return { ...payload, organization_id: organizationId };
};

export const appendOrganizationIdToUrl = (url: string): string => {
  const organizationId = getOrganizationId();
  if (!organizationId) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}organization_id=${encodeURIComponent(organizationId)}`;
};
